export default "__VITE_ASSET__CKFocdpG__"